import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { NavItem, NavLink } from 'reactstrap';
import {
    faCaretDown,
    faCaretUp,
    faWarning
} from "@fortawesome/free-solid-svg-icons";
import { Link } from 'react-router-dom';

export default function SidebarItem({ text, icon, link, onClick, submenu, collapsed, subItem, active, warning }) {

    //Se o item já é a rota ativa, o React Router não navega (mesma rota) e a tela nunca recarrega;
    //forçamos o reload para que o usuário consiga atualizar a tela clicando no próprio item do menu.
    const handleClick = (e) => {
        if (active && link)
            window.location.reload();

        onClick && onClick(e);
    };

    return (
        <NavItem onClick={handleClick} className={`sidebarItem ${active ? "active" : ""}`}>
            {link
                ? <NavLink tag={Link} to={link} className={`d-flex align-items-center justify-content-between`}>
                    <div className='d-flex align-items-center justify-content-center'>
                        {icon && <FontAwesomeIcon icon={icon} className={`topBarBtnIcon ${subItem ? "submenuItem" : ""}`} />}
                        <p className={`textSidebarItem ml-2 mb-0 ${submenu ? "submenuItem" : ""} `}>{text}</p>
                    </div>
                    {warning && <span className='warning-sidebar'><FontAwesomeIcon icon={faWarning} /></span>}
                </NavLink>
                :
                <NavLink className="d-flex align-items-center justify-content-between">
                    <div className='d-flex align-items-center justify-content-center'>
                        {icon && <FontAwesomeIcon icon={icon} className=" iconSidebarItem" />}
                        <p className={`textSidebarItem ${submenu ? "submenu" : ""} ml-2 mb-0`}>{text}</p>
                    </div>
                    {submenu ? collapsed ? <FontAwesomeIcon icon={faCaretUp} className=" w-25" /> : <FontAwesomeIcon icon={faCaretDown} className=" w-25" /> : <></>}
                </NavLink>
            }

        </NavItem>
    );
}